import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { fetchDrawInfo } from "../../model/app/actions";

const useFetchDrawInfo = (id, uuid) => {
  const user = useSelector((state) => {
    return state.oidc.user;
  });
  const apiUrl = useSelector((state) => {
    return state.app.apiUrl;
  });
  const [drawInfo, setDrawInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!apiUrl || (!id && !uuid)) {
      setLoading(false);
      setDrawInfo(null);
      return undefined;
    }

    let isMounted = true;
    setLoading(true);
    fetchDrawInfo(apiUrl, user, id, uuid).then((data) => {
      if (!isMounted) {
        return;
      }

      setLoading(false);
      setDrawInfo(Array.isArray(data) ? data.results[0] : data);
    });

    return () => {
      isMounted = false;
    };
  }, [apiUrl, user, id, uuid]);

  return { drawInfo, loading };
};

export default useFetchDrawInfo;
